export class ProdCalendarDay {
    prodCalendarDayId: number;
    prodCalendarId: number;
    day: Date;
    dayType: number;
    dayTypeString: string;
}